var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',[_vm._v("我是公共aside")])
}
var staticRenderFns = []

export { render, staticRenderFns }